var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { InnerStepContainer, StepContainer, StyledCpslTileButton } from '../common.js';
import { CpslButton, CpslIcon, CpslSpinner, CpslText } from '@usecapsule/react-components';
import { useBuyCryptoClick } from '../../hooks/useBuyCryptoClick.js';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { useExternalWallets } from '../../providers/ExternalWalletContext.js';
import { useState } from 'react';
import { EnabledFlow } from '@usecapsule/web-sdk';
export const Account = ({ onClose }) => {
    const onBuyCryptoClick = useBuyCryptoClick();
    const onRampConfig = useModalStore(state => state.onRampConfig);
    const setAccountAddFundTab = useModalStore(state => state.setAccountAddFundTab);
    const capsule = useCapsuleStore(state => state.capsule);
    const { disconnectExternalWallet } = useExternalWallets();
    const [isDisconnecting, setIsDisconnecting] = useState(false);
    const isOnRampLoaded = !!onRampConfig;
    const handleBuyClick = () => {
        setAccountAddFundTab(EnabledFlow.BUY);
        onBuyCryptoClick();
    };
    const handleReceiveClick = () => {
        setAccountAddFundTab(EnabledFlow.RECEIVE);
        onBuyCryptoClick();
    };
    const handleSellClick = () => {
        setAccountAddFundTab(EnabledFlow.WITHDRAW);
        onBuyCryptoClick();
    };
    const handleDisconnectClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsDisconnecting(true);
        yield capsule.logout();
        yield disconnectExternalWallet();
        onClose();
        setIsDisconnecting(false);
    });
    return (_jsx(StepContainer, { "$wide": true, children: _jsxs(InnerStepContainer, { children: [_jsx(ButtonContainer, { children: isOnRampLoaded ? (_jsxs(_Fragment, { children: [onRampConfig.isBuyEnabled && (_jsx(OptionButton, { icon: "creditCard", onClick: handleBuyClick, children: _jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Buy Crypto" }) })), onRampConfig.isReceiveEnabled && (_jsx(OptionButton, { icon: "qrCode02", onClick: handleReceiveClick, children: _jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Receive" }) })), onRampConfig.isWithdrawEnabled && (_jsx(OptionButton, { icon: "arrowCircleBrokenDownLeft", onClick: handleSellClick, children: _jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Withdraw" }) }))] })) : (_jsx(CpslSpinner, {})) }), _jsx(DisconnectButton, { variant: "destructive", fullWidth: true, onClick: handleDisconnectClick, disabled: isDisconnecting, children: isDisconnecting ? (_jsx(CpslSpinner, { size: 16 })) : (_jsxs(_Fragment, { children: ["Disconnect Wallet", _jsx(CpslIcon, { icon: "logOut", slot: "end" })] })) })] }) }));
};
const ButtonContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 88px;
`;
const OptionButton = styled(StyledCpslTileButton) `
  flex: 1;

  --button-icon-color: var(--cpsl-color-text-primary);
`;
const DisconnectButton = styled(CpslButton) `
  --button-border-width: 0px;
`;
